import { render, staticRenderFns } from "./ticket-to-direct-debit-file-modal.vue?vue&type=template&id=4b22cf2a&scoped=true&"
import script from "./ticket-to-direct-debit-file-modal.ts?vue&type=script&lang=ts&"
export * from "./ticket-to-direct-debit-file-modal.ts?vue&type=script&lang=ts&"
import style0 from "./ticket-to-direct-debit-file-modal.scss?vue&type=style&index=0&id=4b22cf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22cf2a",
  null
  
)

export default component.exports